import React from "react";

import DateTimeRangeComponent from "./DateTimeRangeComponent";
import MonthDayRangeComponent from "./MonthDayRangeComponent";
//import NumericRangeComponent from "./NumericRangeComponent";
import DurationRangeComponent from "./DurationRangeComponent";

// Component for updating X, Y, Y2 Axis Ranges (NOT filter ranges)
function RangeFilterComponent({
    min,
    max,
    Dyn,
    type,
    attributeObj,
    label,
    onChange,
}) {
    const types = type.split(":"),
        dataType = types[0],
        subType = types[1];

    return (
        <div className="tde-numeric-component">
            {subType == "date" ||
            subType == "time" ||
            subType == "datetime" ||
            subType == "yearMonth" ||
            subType == "monthYear" ? (
                <DateTimeRangeComponent
                    min={min}
                    max={max}
                    Dyn={Dyn}
                    mode={subType}
                    label={label}
                    onChange={onChange}
                />
            ) : subType == "month" || subType == "dayOfWeek" ? (
                <MonthDayRangeComponent
                    min={min}
                    max={max}
                    Dyn={Dyn}
                    mode={subType}
                    label={label}
                    onChange={onChange}
                />
            ) : ( // subType === undefined, "duration", "durationHM", "extractedNumber", "fraction", "year"
                <DurationRangeComponent
                    min={min}
                    max={max}
                    Dyn={Dyn}
                    mode={subType}
                    attributeObj={attributeObj}
                    onChange={onChange}
                />
            )}
        </div>
    );
}

export default RangeFilterComponent;
